import { useEffect, useRef, useState } from "react";
import CompScroll from "./CompScroll";
import { useMediaQuery } from "react-responsive";

//슬라이드
function MainHome() {
  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  //슬라이드 객체
  const [slideItem, setSlideItem] = useState(null);
  //버튼 객체
  const [btnItem, setBtnItem] = useState(0);
  //버튼 useRef
  const onBtn = useRef();

  //슬라이드 선택
  useEffect(() => {
    let slideBtn = 1;

    const slideItems =
      document.getElementsByClassName("js-slider-item")[0].children;
    setSlideItem(slideItems);

    const btnItems =
      document.getElementsByClassName("js-slider-btn")[0].children;
    setBtnItem(btnItems);

    setInterval(function () {
      if (slideItem?.length !== undefined) {
        slideClassRemove(slideItem);
        slideClassRemove(btnItem);

        if (slideBtn < slideItem.length) {
          slideItem[slideBtn].classList.add("active-on");
          btnItem[slideBtn].classList.add("active-on");
          slideBtn++;
        }
        if (slideBtn === slideItem.length) {
          slideBtn = 0;
        }
      }
    }, 3000);

    //클릭에 따른 슬라이드
    onBtn.current.addEventListener("click", (e) => {
      let targetValue = e.target.value;
      let sliderActive = slideItem?.[targetValue];

      if (targetValue !== undefined) {
        targetValue = Number(targetValue);
        slideClassRemove(slideItem);
        slideClassRemove(btnItem);

        if (targetValue < 3) {
          sliderActive?.classList.add("active-on");
          btnItem[targetValue]?.classList.add("active-on");
          slideBtn = targetValue;
        }
      }
    });
  }, [slideItem, btnItem]);

  //active-on 클래스 삭제
  function slideClassRemove(arr) {
    for (let i = 0; i < arr?.length; i++) {
      arr[i].classList.remove("active-on");
    }
  }

  return (
    <>
      <div className="slider-btn-item-wrap">
        <div className="slider-btn-item-box">
          <div className="slider-horizontal-btn-item js-slider-btn" ref={onBtn}>
            <button className="slider-btn-list active-on" value={0}>
              <span className="slider-btn"></span>
            </button>
            <button className="slider-btn-list" value={1}>
              <span className="slider-btn"></span>
            </button>
            <button className="slider-btn-list" value={2}>
              <span className="slider-btn"></span>
            </button>
          </div>
          {/* <button className="slider-main-btn active-on"></button> */}
        </div>
      </div>
      <div className="js-slider-item">
        <div className="slider-list active-on">
          <div className="slider-txt-wrap">
            {/* animation-test-item animation-test-item2 animation-on */}
            <p className="slider-idx">THE PIONEER</p>
            <h2 className="slider-title">It's Heliosen</h2>
            <div className="slider-subtitle">
              {pc ? (
                <>
                  <p>4차 산업 혁명 핵심 기술과 공간 정보 융복합 서비스로</p>
                  <p>전 세계 디지털 혁신의 선두주자가 되겠습니다.</p>
                </>
              ) : (
                <>
                  <p>4차 산업 혁명 핵심 기술과 공간 정보</p>
                  <p>융복합 서비스로 전 세계 디지털 혁신의</p>
                  <p>선두주자가 되겠습니다.</p>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="slider-list">
          <div className="slider-txt-wrap">
            <p className="slider-idx">Specialized Company</p>
            <h2 className="slider-title">Digital Twin</h2>
            <div className="slider-subtitle">
              {pc ? (
                <>
                  <p>수요자 요구에 맞는 디지털 트윈 솔루션 제공으로</p>
                  <p>산업별 디지털 혁신을 지원하겠습니다.</p>
                </>
              ) : (
                <>
                  <p>수요자 요구에 맞는 디지털 트윈 솔루션</p>
                  <p> 제공으로 산업별 디지털 혁신을 지원하겠습니다.</p>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="slider-list">
          <div className="slider-txt-wrap">
            <p className="slider-idx">Create a collaborative</p>
            {pc ? (
              <>
                <h2 className="slider-title">Corporate culture</h2>
              </>
            ) : (
              <>
                <h2 className="slider-title">
                  <span className="txt">Corporate</span>
                  <span className="txt">culture</span>
                </h2>
              </>
            )}
            <div className="slider-subtitle">
              {pc ? (
                <>
                  <p>배려와 공감과 상호 존중을 바탕으로 서로에게 힘이 되는</p>
                  <p>회사 문화를 만들어가겠습니다.</p>
                </>
              ) : (
                <>
                  <p>배려와 공감과 상호 존중을 바탕으로 서로에게</p>
                  <p>힘이 되는 회사 문화를 만들어가겠습니다.</p>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <CompScroll value={1} />
    </>
  );
}

export default MainHome;
